<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <form @submit.prevent="submit" class="card-body">
        <div>
          <div v-if="getPermission(1030).view" class="col-md-6">
            <label class="form-control-label required" for="companyTitle">شرکت</label>
            <treeselect v-model="companyId" :multiple="false" :placeholder="companyTitle ?? 'انتخاب کنید'"
              :showCount="true" noOptionsText="هنوز شرکتی تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است" :options="companies" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="title">عنوان نقش</label>
            <input class="form-control" type="text" id="title" name="title" v-model.trim="title" />
          </div>
          <hr class="horizontal dark" />
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="isPersonnelDefault" id="isPersonnelDefault">
            <label class="form-check-label" for="isPersonnelDefault">پیش فرض کاربران جدید</label>
          </div>
        </div>
        <hr class="horizontal dark" />
        <div class="py-2 container-fluid">
          <show-access-group-permission :open="isNew" :current-permissions="rolePermissions"
            @modify-permission="modifyPermission" />
        </div>
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit">ثبت</button>
          <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/Company/Company-service.js';
import RoleService from '@/services/User/Role-service.js';
import ShowAccessGroupPermission from "./ShowAccessGroupPermission.vue";
import { maxLength, helpers, required } from '@vuelidate/validators';
import Treeselect from '@cholakovdev/vue3-treeselect';
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      v: this.$useVuelidate(),
      id: null,
      title: '',
      companies: [],
      isNew: true,
      isCopy: false,
      companyTitle: '',
      isPersonnelDefault: false,
      rolePermissions: [],
      companyId: null,
      companyTitle: null,
      companyChanged: false,
    };
  },
  components: { ShowAccessGroupPermission, Treeselect },
  computed: {
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId() {
      if (this.companyChanged) { this.companyTitle = null; }
      this.companyChanged = true;
    }
  },
  methods: {
    submit() {
      this.v.$validate();

      if (this.v.$error) {
        return;
      }

      let role = {
        Id: this.id ?? 0,
        Title: this.title,
        CompanyId: this.companyId,
        IsPersonnelDefault: this.isPersonnelDefault,
        ModifiedOrAddedRolePermissions: this.isCopy ? this.rolePermissions : this.rolePermissions.filter(x => (x.added && x.view) || x.modified),
      };

      if (!this.isNew & !this.isCopy) {
        RoleService.updateRole(role).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.goBack(), 500);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        RoleService.addRole(role).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.goBack(), 500);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      this.v.$reset();
    },
    getRole() {
      RoleService.getRole(this.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.title = result.data.title;
          this.rolePermissions = result.data.rolePermissions;
          this.isPersonnelDefault = result.data.isPersonnelDefault;
          this.companyId = result.data.companyId;
          this.companyTitle = result.data.companyTitle;
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCompany(companyId) {
      CompanyService.getCompany(companyId).then(response => {
        let result = response.data;

        if (result.success) {
          this.company = result.data;
          if (!this.isNew) {
            this.companies.push(this.company);
          }
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    goBack() {
      if (this.companyId > 0) {
        this.$router.push('/roles/' + this.companyId);
      }
      else {
        this.$router.back();
      }
    },
    modifyPermission(permission) {
      let index = this.rolePermissions.map(x => x.permissionId).indexOf(permission.permissionId);

      if (index > -1) {
        this.rolePermissions[index].view = permission.view;
        this.rolePermissions[index].insert = permission.insert;
        this.rolePermissions[index].update = permission.update;
        this.rolePermissions[index].delete = permission.delete;
        if (!this.rolePermissions[index].added) {
          this.rolePermissions[index].modified = true;
        }
      }
      else {
        this.rolePermissions.push({
          permissionId: permission.permissionId,
          view: permission.view,
          insert: permission.insert,
          update: permission.update,
          delete: permission.delete,
          added: true,
        });
      }
    }
  },
  created() {
    this.isCopy = this.$route.meta.copy;
    this.isNew = this.$route.meta.new;

    this.companies.push(this.$store.state.currentUserInfo.companies);

    if (this.isNew) {
      this.id = 0;
      setTimeout(() => this.rolePermissions = [], 200);

      if (this.$route.params.companyId > 0) {
        this.companyId = this.$route.params.companyId;
      }
    }

    if (!this.isNew) {
      this.id = this.$route.params.roleId;

      this.getRole();
    }
  },
  validations() {
    let valObj = {
      companyId: {
        required: helpers.withMessage('لطفا "شرکت" مربوطه را انتخاب کنید', required),
      },
      title: {
        required: helpers.withMessage('لطفا "عنوان نقش" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "عنوان نقش"، 250 کاراکتر است', maxLength(250)),
      },
    };

    return valObj;
  }
}
</script>